import { getEnvVar } from '../../../../envUtils';

const BASE = () => getEnvVar('REACT_APP_BACKEND_BASE_URL');

const query = (params: Record<string, string>) => new URLSearchParams(params).toString();

export const GS_ENDPOINTS = {
  // POST (create) - no groundstationid in query
  create:  (missionId: string, scenarioId: string) =>
    `${BASE()}mission-simulation/groundstation?${query({ missionid: missionId, scenarioid: scenarioId })}`,

  getAll:  (missionId: string, scenarioId: string) =>
    `${BASE()}mission-simulation/groundstation/all?${query({ missionid: missionId, scenarioid: scenarioId })}`,

  // GET with groundstationid
  getById: (missionId: string, scenarioId: string, gsId: string) =>
    `${BASE()}mission-simulation/groundstation?${query({ missionid: missionId, scenarioid: scenarioId, groundstationid: gsId })}`,

  // PATCH (update) - with groundstationid
  update:  (missionId: string, scenarioId: string, gsId: string) =>
    `${BASE()}mission-simulation/groundstation?${query({ missionid: missionId, scenarioid: scenarioId, groundstationid: gsId })}`,

  // DELETE - with groundstationid
  delete:  (missionId: string, scenarioId: string, gsId: string) =>
    `${BASE()}mission-simulation/groundstation?${query({ missionid: missionId, scenarioid: scenarioId, groundstationid: gsId })}`,

  deleteMany: (missionId: string, scenarioId: string) =>
    `${BASE()}mission-simulation/groundstation/all/delete?${query({ missionid: missionId, scenarioid: scenarioId })}`,
};

export const AOI_ENDPOINTS = {
  create: (missionId: string, scenarioId: string) =>
    `${BASE()}mission-simulation/geofeature?${query({ missionid: missionId, scenarioid: scenarioId })}`,

  getAll: (missionId: string, scenarioId: string) =>
    `${BASE()}mission-simulation/geofeature/all?${query({ missionid: missionId, scenarioid: scenarioId })}`,

  getById: (missionId: string, scenarioId: string, aoiId: string) =>
    `${BASE()}mission-simulation/geofeature?${query({ missionid: missionId, scenarioid: scenarioId, areaofinterestid: aoiId })}`,

  update: (missionId: string, scenarioId: string, aoiId: string) =>
    `${BASE()}mission-simulation/geofeature?${query({ missionid: missionId, scenarioid: scenarioId, areaofinterestid: aoiId })}`,

  delete: (missionId: string, scenarioId: string, aoiId: string) =>
    `${BASE()}mission-simulation/geofeature?${query({ missionid: missionId, scenarioid: scenarioId, areaofinterestid: aoiId })}`,

  deleteMany: (missionId: string, scenarioId: string) =>
    `${BASE()}mission-simulation/geofeature/all/delete?${query({ missionid: missionId, scenarioid: scenarioId })}`,
};
